<template>
    <div>
        <st-data-table
            :items="rows"
            :fields="fields"
            :actions="actions"
            :modelPresenter="presenter"
            @edit="onEdit"
            @delete="onDelete"
            responsive="sm"
            hover
        >
        </st-data-table>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { ApplicationTypeModel } from '@/modules/application-type/application-type-model';

    const { fields } = ApplicationTypeModel;

    export default {
        name: 'applicationTypeListTable',
        data() {
            return {
                presenter: ApplicationTypeModel.presenter,
                actions: [
                    {
                        name: 'edit',
                        icon: 'edit',
                        tooltipText: this.$t('GENERAL.ACTIONS.EDIT'),
                        customIcon: false,
                        type: 'primary'
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                        tooltipText: this.$t('GENERAL.ACTIONS.DELETE'),
                        customIcon: false,
                        type: 'primary'
                    }
                ],
            };
        },
        computed: {
            ...mapGetters({
                rows: 'applicationType/list/rows',
            }),
            fields() {
                return [
                    fields.name,
                    fields.status,
                ]
            }
        },
        methods: {
            ...mapActions({
                selectRecord: 'applicationType/form/select',
                deleteRecord: 'applicationType/form/remove',
            }),
            async onEdit(data) {
                await this.selectRecord(data.item);
                this.$emit('editApplication');
            },
            async onDelete(data) {
                await this.deleteRecord(data.item.id);
            },
        },
    };
</script>

